export const CREATE_TIMESHEET_ENTRY_REQUEST = 'CREATE_TIMESHEET_ENTRY_REQUEST';
export const CREATE_TIMESHEET_ENTRY_REQUEST_FAILURE = 'CREATE_TIMESHEET_ENTRY_REQUEST_FAILURE';
export const CREATE_TIMESHEET_ENTRY_REQUEST_FINALLY = 'CREATE_TIMESHEET_ENTRY_REQUEST_FINALLY';
export const CREATE_TIMESHEET_ENTRY_REQUEST_SUCCESS = 'CREATE_TIMESHEET_ENTRY_REQUEST_SUCCESS';

export const CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST = 'CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST';
export const CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST_FAILURE = 'CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST_FAILURE';
export const CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST_SUCCESS = 'CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST_SUCCESS';

export const CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST = 'CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST';
export const CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST_FAILURE = 'CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST_FAILURE';
export const CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST_SUCCESS = 'CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST_SUCCESS';

export const DELETE_TIMESHEET_ENTRY_REQUEST = 'DELETE_TIMESHEET_ENTRY_REQUEST';
export const DELETE_TIMESHEET_ENTRY_REQUEST_FAILURE = 'DELETE_TIMESHEET_ENTRY_REQUEST_FAILURE';
export const DELETE_TIMESHEET_ENTRY_REQUEST_SUCCESS = 'DELETE_TIMESHEET_ENTRY_REQUEST_SUCCESS';

export const GET_TIMESHEET_ENTRIES_REQUEST = 'GET_TIMESHEET_ENTRIES_REQUEST';
export const GET_TIMESHEET_ENTRIES_REQUEST_FAILURE = 'GET_TIMESHEET_ENTRIES_REQUEST_FAILURE';
export const GET_TIMESHEET_ENTRIES_REQUEST_SUCCESS = 'GET_TIMESHEET_ENTRIES_REQUEST_SUCCESS';

export const RESET_TIMESHEET_ENTRIES_STATE = 'RESET_TIMESHEET_ENTRIES_STATE';

export const UPDATE_TIMESHEET_ENTRY_REQUEST = 'UPDATE_TIMESHEET_ENTRY_REQUEST';
export const UPDATE_TIMESHEET_ENTRY_REQUEST_FAILURE = 'UPDATE_TIMESHEET_ENTRY_REQUEST_FAILURE';
export const UPDATE_TIMESHEET_ENTRY_REQUEST_SUCCESS = 'UPDATE_TIMESHEET_ENTRY_REQUEST_SUCCESS';
export const UPDATE_TIMESHEET_ENTRY_REQUEST_FINALLY = 'UPDATE_TIMESHEET_ENTRY_REQUEST_FINALLY';
